import type { ReactNode } from "react";
import type { WhClass, WhEffect } from "../types/chain";
import { CLASS_LABEL } from "../lib/systemClass";

const EFFECT_NAME: Record<NonNullable<WhEffect>, string> = {
  Pulsar: "Pulsar",
  Magnetar: "Magnetar",
  WolfRayet: "Wolf-Rayet",
  BlackHole: "Black Hole",
  CataclysmicVariable: "Cataclysmic Variable",
  RedGiant: "Red Giant",
};

const EFFECT_SHORT_NAME: Partial<Record<NonNullable<WhEffect>, string>> = {
  CataclysmicVariable: "Cataclysmic",
};

const EFFECT_COLOR: Record<NonNullable<WhEffect>, string> = {
  Pulsar: "#6aaaff",
  Magnetar: "#e8a8d8",
  WolfRayet: "#f0a020",
  BlackHole: "#0f1115",
  CataclysmicVariable: "#f3e29b",
  RedGiant: "#e0524a",
};

const J_DESIGNATOR = /^J(\d{3})(\d{3})$/;

export function ClassBadge({ systemClass }: { systemClass: WhClass }) {
  return (
    <span
      className={`system-node__class system-class--${systemClass}`}
      title={systemClass}
    >
      {CLASS_LABEL[systemClass]}
    </span>
  );
}

interface SystemIdentityProps {
  systemClass: WhClass;
  name: string;
  effect: WhEffect;
  plainName?: boolean;
  effectAsText?: boolean;
  children?: ReactNode;
}

export function SystemIdentity({
  systemClass,
  name,
  effect,
  plainName = false,
  effectAsText = false,
  children,
}: SystemIdentityProps) {
  const jMatch = plainName ? null : name.match(J_DESIGNATOR);
  return (
    <>
      <ClassBadge systemClass={systemClass} />
      <span className="system-node__name">
        {jMatch ? (
          <>
            J{jMatch[1]}
            <span
              style={{
                marginLeft: "0.3em",
                paddingBottom: "0.1em",
                color: "#00fffb",
                borderBottom: "1px solid #389c9a",
              }}
            >
              {jMatch[2]}
            </span>
          </>
        ) : (
          name
        )}
        {children}
      </span>
      {effect &&
        (effectAsText ? (
          <span className="system-identity__effect">
            <span
              className={`system-node__effect system-node__effect--${effect}`}
              style={{ background: EFFECT_COLOR[effect] }}
            />
            <span
              className="system-identity__effect-text"
              style={{
                color:
                  effect === "BlackHole" ? "#ffffff" : EFFECT_COLOR[effect],
              }}
              title={EFFECT_NAME[effect]}
            >
              {EFFECT_SHORT_NAME[effect] ?? EFFECT_NAME[effect]}
            </span>
          </span>
        ) : (
          <span
            className={`system-node__effect system-node__effect--${effect}`}
            style={{ background: EFFECT_COLOR[effect] }}
            title={EFFECT_NAME[effect]}
          />
        ))}
    </>
  );
}
